module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab126-5b8dc53ca67ba99ce81bf42441be9622.jpg";